module.exports = __webpack_public_path__ + "fonts/Montserrat-Thin.43dd5b7a.ttf";